import { render, staticRenderFns } from "./MapChina.vue?vue&type=template&id=76a291d2"
import script from "./MapChina.vue?vue&type=script&lang=js"
export * from "./MapChina.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.21_css-loader@6.11.0_webpack@5.101.3__lodash@4.17.21_kzgbr7tkrfh4tbz6eswufdvi6i/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports